import React from "react";
import WebFont from "webfontloader";
import ReactGA from "react-ga";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { DARK_MODE_HASH } from "./constants";

import Menu from "./components/Menu";
import Homepage from "./Homepage";
import About from "./About";
import Acknowledgements from "./Acknowledgements";
import GAListener from "./GAListener";

import "./App.scss";

const trackingId = "UA-153597890-1";

if (process.env.NODE_ENV !== "test") {
  ReactGA.initialize(trackingId);
}

function VideoRedirect() {
  React.useEffect(() => {
    window.location.href =
      "//www.youtube.com/channel/UCsQ5-o7tNvSxfAl8YjplKnw/";
  }, []);

  return null;
}

function CollectionRoutes({ hidden }) {
  const location = useLocation();
  const displayMode = location.hash === DARK_MODE_HASH ? "dark" : "light";

  React.useEffect(() => {
    document.body.classList.toggle("dark", displayMode === "dark");
    return () => document.body.classList.remove("dark");
  }, [displayMode]);

  return (
    <GAListener>
      <Routes>
        <Route path="/videos" element={<VideoRedirect />} />
        <Route
          path="/about"
          element={
            <>
              <Menu page="about" displayMode={displayMode} />
              <About displayMode={displayMode} />
            </>
          }
        />
        <Route
          path="/thanks"
          element={
            <>
              <Menu page="thanks" displayMode={displayMode} />
              <Acknowledgements displayMode={displayMode} />
            </>
          }
        />
        <Route
          path="/:x?/:y?/:hash?"
          element={
            <>
              <Menu page="home" displayMode={displayMode} />
              <Homepage hidden={hidden} displayMode={displayMode} />
            </>
          }
        />
      </Routes>
    </GAListener>
  );
}

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hideMap: true };
    WebFont.load({ typekit: { id: "ikz3unr" } });
  }

  componentDidMount() {
    this.showMapTimer = window.setTimeout(() => {
      this.setState({ hideMap: false });
    }, 500);
  }

  componentWillUnmount() {
    window.clearTimeout(this.showMapTimer);
  }

  render() {
    return (
      <Router>
        <CollectionRoutes hidden={this.state.hideMap} />
      </Router>
    );
  }
}
